const configSystem = {
  URL_API: process.env.REACT_APP_API_KEY,
  // URL_API: 'https://webcol.herokuapp.com/',
  // URL_API: 'http://localhost:4000/',
  JWT_SECRET: '95c5ebbd38cd08f1f45ebef2d479349d',
};

export default configSystem;
